var t=t=>{let e=new AbortController;return setTimeout((()=>e.abort()),t),e.signal};export{t as default};
